import React, { Component } from "react";
import WaveSurfer from "wavesurfer.js";
import {
  Box,
} from "@mui/material";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';

class Waveform extends Component {
  
  state = {
    playing: false,
    duration: 0,
    currentTime: 0
  };


  componentDidMount() {
    const track = document.querySelector("#track");

    // this.waveform = WaveSurfer.create(options);
    this.waveform = WaveSurfer.create({
      // barWidth: 3,
      barRadius: 1,
      // barGap: NaN,
      // barMinHeight: 1,
      // cursorWidth: 1,
      container: "#waveform",
      // backend: "WebAudio",
      height: 130,
      
      // responsive: true,
      waveColor: "#2CC382",
      progressColor: "#51bff1",
      cursorColor: "#FF0000",
      // 추가
      splitChannels: false,
      normalize: false,
      cursorWidth: 3,
      barWidth: 1.5,
      // barHeight: 0.5,
      // barMinHeight: 1,
      barHeight: 3,
      fillParent: true,
      hideScrollbar: true,

    });

    this.waveform.on("ready", () => {
      const audioDuration = this.waveform.getDuration();
      this.setState({ duration: audioDuration.toFixed(3) });
    });

    this.waveform.on("audioprocess", () => {
      const currentTime = this.waveform.getCurrentTime();
      this.setState({ currentTime: currentTime.toFixed(3) });
    });

    this.waveform.load(track);
  }

  handlePlay = () => {
    // console.log('토글')
    this.setState({ playing: !this.state.playing });
    this.waveform.playPause();
    // wavesurfer.skip(5) 5 , -5
  };

  handleTimeChange = (event) => {
    const newTime = parseFloat(event.target.value);
    this.waveform.setCurrentTime(newTime.toFixed(3));
    this.setState({ currentTime: newTime.toFixed(3) });
    // console.log('newTime' , newTime)
  };

  componentDidUpdate(prevProps) {
    const { open, stopWaveform } = this.props;
    const { playing } = this.state;
    // const { playing, duration, currentTime } = this.state;

    // console.log('waveform url',url)

    if(!open && !playing){
      stopWaveform();
      this.setState({ playing: false });
    }else if (open !== prevProps.open && !open && playing && !prevProps.open) {
      this.handlePlay();
      stopWaveform();
      this.setState({ playing: false });
    }else if(!open && playing){
      this.handlePlay();
      stopWaveform();
      this.setState({ playing: false });
    }

  }

  render() {

    const { url } = this.props;

    // console.log('url', url)
    // const { url, open} = this.props;

    // const { playing } = this.state;

    // console.log('url wavform' , url)

    // console.log('상태' , open, playing )
    // console.log('========================')

    // const url =
    //   window.location.origin.replace(':3000',':9680')+"/sampleAudioInfo?idx=22";

    // console.log('waveform url',url)

    return (
      <React.Fragment>
      <Box sx={{display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        height: "138px",
        width: "95%",
        // background: "transparent",
        border : "3px solid #3e36a5",
        borderRadius : "3px",
        margin: "12px",
        padding: "8px",
        gap: "2rem"}}>
        <div style={{width: "100%", height: "130px"}} id="waveform" />
        <audio id="track" src={url} />
      </Box>
      
      <Box display="flex" sx={{margin: "0 16px",alignItems:"center"}}>
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "54px",
          height: "46px",
          background: !this.state.playing ? "#3e36a5": "red",
          borderRadius: "50%",
          border: "none",
          outline: "none",
          cursor: "pointer",
          paddingBottom: "3px",
          color: "#fff",
          marginRight:"16px",
          "&:hover": {
            background: "green",
            color: "#fff"
          }
        }} onClick={this.handlePlay}>
          {!this.state.playing ? <PlayCircleIcon fontSize="large" /> : <PauseCircleIcon fontSize="large" />}
        </Box>
        <Box display="flex" sx={{marginRight:"16px", fontWeight:800}}>
          <Box sx={{fontWeight:700, marginBottom:"4px",marginRight:"8px"}}>시간 컨트롤</Box>
          <Box><input
          type="range"
          min={0}
          max={this.state.duration}
          value={this.state.currentTime}
          onChange={this.handleTimeChange}
        /></Box>
        </Box>
        <Box display="flex" sx={{marginRight:"16px", fontWeight:800}}>
          <Box sx={{fontWeight:700, marginBottom:"4px",marginRight:"8px"}}>재생 시간 :</Box>
          <Box>{this.state.currentTime} Sec</Box>
        </Box>
        <Box display="flex" sx={{marginRight:"16px", fontWeight:800}}>
          <Box sx={{fontWeight:700, marginBottom:"4px",marginRight:"8px"}}>총 길이 :</Box>
          <Box>{this.state.duration} Sec</Box>
        </Box>
      </Box>
      </React.Fragment>
    );
  }
}

export default Waveform;
